/**
 * Cores por categoria de termos customizados
 * Extraído de legalTerms.ts para uso independente
 */

export const CATEGORY_COLORS: Record<string, { bg: string; text: string; label: string }> = {
  processual: { bg: '#e3f2fd', text: '#1565c0', label: 'Processual' },
  penal: { bg: '#fce4ec', text: '#c62828', label: 'Penal' },
  civel: { bg: '#e8f5e9', text: '#2e7d32', label: 'Cível' },
  constitucional: { bg: '#fff3e0', text: '#e65100', label: 'Constitucional' },
  trabalhista: { bg: '#f3e5f5', text: '#7b1fa2', label: 'Trabalhista' },
  geral: { bg: '#eceff1', text: '#455a64', label: 'Geral' },
  jurídico: { bg: '#e3f2fd', text: '#1565c0', label: 'Jurídico' },
  pessoa: { bg: '#fff3e0', text: '#e65100', label: 'Pessoa' },
  organização: { bg: '#e8f5e9', text: '#2e7d32', label: 'Organização' },
  local: { bg: '#f3e5f5', text: '#7b1fa2', label: 'Local' },
  data: { bg: '#fff9c4', text: '#f57f17', label: 'Data' },
  valor: { bg: '#fce4ec', text: '#c62828', label: 'Valor' },
  tópico: { bg: '#e0f7fa', text: '#00695c', label: 'Tópico' },
}

/**
 * Retorna cor para uma categoria, com fallback para 'geral'
 */
export function getCategoryColor(category: string): { bg: string; text: string; label: string } {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS['geral']
}
